import _get from 'lodash/get';
import _property from 'lodash/property';
import _isEmpty from 'lodash/isEmpty';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var glGlAccountLabel = function glGlAccountLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  if (_isEmpty(option)) {
    return '';
  }
  var accountNumber = _get(option, 'data.accountNumber');
  var accountName = _get(option, 'data.accountName');
  return "".concat(accountNumber, " - ").concat(accountName);
};
var glGlAccountValue = _property('data.id');
var GL_ACCOUNT_OPTION_CONFIG = {
  getOptionLabel: glGlAccountLabel,
  getOptionValue: glGlAccountValue
};
export default GL_ACCOUNT_OPTION_CONFIG;